import _ from 'lodash';
const internalDateFormats = {};
const internalStrings = {};
const internalNumberFormats = {};
export const dateFormats = internalDateFormats;
export const strings = internalStrings;
export const numberFormats = internalNumberFormats;
export function updateDateFormats(obj) {
    _.merge(internalDateFormats, obj);
}
export function updateStrings(obj) {
    _.merge(internalStrings, obj);
}
export function updateNumberFormats(obj) {
    _.merge(internalNumberFormats, obj);
}
//# sourceMappingURL=translations.js.map